import React from 'react';

interface PaginationProps {
  classes?: string;
  onClickHandler?: any;
  id?: string;
  totalCount: number;
  currentPage: number;
  countPerPage: number;
}

const Pagination = ({
  classes,
  onClickHandler,
  totalCount,
  currentPage,
  countPerPage,
}: PaginationProps) => {
  const getPager = (
    totalCount: number,
    currentPage: number,
    countPerPage: number
  ) => {
    // calculate total pages
    const totalPages = Math.ceil(totalCount / countPerPage);

    // ensure current page isn't out of range
    if (currentPage < 1) {
      currentPage = 1;
    } else if (currentPage > totalPages) {
      currentPage = totalPages;
    }

    let startPage: number, endPage: number;
    if (totalPages <= 10) {
      // less than 10 total pages so show all
      startPage = 1;
      endPage = totalPages;
    } else {
      // more than 10 total pages so calculate start and end pages
      if (currentPage <= 6) {
        startPage = 1;
        endPage = 10;
      } else if (currentPage + 4 >= totalPages) {
        startPage = totalPages - 9;
        endPage = totalPages;
      } else {
        startPage = currentPage - 5;
        endPage = currentPage + 4;
      }
    }
    // create an array of pages to ng-repeat in the pager control
    const pages = Array.from(Array(endPage + 1 - startPage).keys()).map(
      i => startPage + i
    );

    const getInfoZeile = () => {
      const rechend = currentPage * countPerPage;
      const end = rechend > totalCount ? totalCount : rechend;
      const rechstart = (currentPage - 1) * countPerPage + 1;
      const start = rechstart < 0 ? 0 : rechstart;
      const info =
        'Anzahl gemäß Suchvorgaben: ' +
        totalCount +
        ' / Anzeige pro Seite:  ' +
        countPerPage +
        ' / Anzeige aktuell:  ' +
        start +
        '-' +
        end;

      return info;
    };

    const calcTableWidth = () => {
      const width = document.getElementById('table')?.offsetWidth;

      return width == undefined ? '100vw' : width + 'px';
    };

    return (
      <div className={'pagination'} style={{ width: calcTableWidth() }}>
        <ul className={'pagination-container'}>
          <li
            onClick={e => {
              e.preventDefault();
              onClickHandler(1);
            }}
            className={
              currentPage === 1 ? 'disabled pagination-item' : 'pagination-item'
            }
          >
            start
          </li>
          <li
            onClick={e => {
              e.preventDefault();
              onClickHandler(currentPage - 1);
            }}
            className={
              currentPage === 1 ? 'disabled pagination-item' : 'pagination-item'
            }
          >
            <div className='arrow left' />
          </li>
          {pages &&
            pages.map((page: number, index: number) => {
              return (
                <li
                  onClick={e => {
                    e.preventDefault();
                    onClickHandler(page);
                  }}
                  key={index}
                  className={
                    currentPage === page
                      ? 'selected pagination-item'
                      : 'pagination-item'
                  }
                >
                  {page}
                </li>
              );
            })}
          <li
            onClick={e => {
              e.preventDefault();
              onClickHandler(currentPage + 1);
            }}
            className={
              currentPage + 1 > totalPages
                ? 'disabled pagination-item'
                : 'pagination-item'
            }
          >
            <div className='arrow right' />
          </li>
          <li
            onClick={e => {
              e.preventDefault();
              onClickHandler(totalPages);
            }}
            className={
              currentPage + 1 > totalPages
                ? 'disabled pagination-item'
                : 'pagination-item'
            }
          >
            ende
          </li>
        </ul>
        <div className={'pagination-infozeile'}>{getInfoZeile()}</div>
      </div>
    );
  };

  return getPager(totalCount, currentPage, countPerPage);
};

export default Pagination;
